import {useEffect, useState} from "react";
import {UserInfoModel} from "../model/ua/user-info";
import {useAppDispatch, useAppSelector} from "../store/hook";
import {firebaseConfig} from "app/config/firebaseConfig";
import {initializeApp} from "firebase/app";
import {onMessage} from "firebase/messaging";
import {messaging, requestPermission} from "../services/common/Firebase";
import {AppDispatch} from "../store/store";
import {FirebaseService} from "../services/common/FirebaseService";
import {updateAlarmMessages} from "../reducers/alarmSlice";
import {toast} from "react-toastify";

const format = (d: Date): string =>
    new Date(d.getTime() - d.getTimezoneOffset() * 60000)
    .toISOString()
    .replace('T', ' ')
    .substring(0, 19);

type GetMessageParams = { userId: string; month: string };

/**
 * 조회 시작일(한 달 전).
 *
 * ★ 부를 때마다 계산한다. 모듈 로드 시점에 한 번 계산해 두면 탭을 오래 열어 둔
 *   사용자의 조회 창이 그대로 밀린다 — 어제 열어 둔 탭은 어제 기준 한 달 전부터
 *   본다. 증상은 "알림이 안 온다" 로 나타나 원인을 찾기 어렵다.
 */
function lastMonth(): Date {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return d;
}

export async function getMessages(dispatch: AppDispatch, newUserInfo: any) {
  try {
    const param: GetMessageParams = {
      month: format(lastMonth()),
      userId: newUserInfo.userId,
    };

    const response = await FirebaseService.getInstance().getMessage(param);

    if (response?.data) {
      dispatch(updateAlarmMessages(response.data));
    }
  } catch (error) {
    console.error("메시지를 가져오는 데 실패하였습니다.", error);
  }
}

const app = initializeApp(firebaseConfig)
export default function AuthGuard(props: any) {
  const dispatch = useAppDispatch();
  const userInfo: UserInfoModel = useAppSelector((state) => state.userInfo.userInfo);

  /**
   * isAuthenticated state value should be false
   * temporary set to true to bypass check authenticated
   * **/
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const fetchToken = async () => {
    const token = await requestPermission();
    if (token) {
      await FirebaseService.getInstance().saveDeviceToken({
        uid: userInfo.userId,
        token: token
      });
      getMessages(dispatch, userInfo);
    }
  };

  useEffect(() => {
    if (userInfo?.userId) {
      fetchToken();
      getMessages(dispatch, userInfo); // 로그인 시 알림메세지 호출
    }
  }, [userInfo?.userId]);

  onMessage(messaging, (payload) => {
    if (payload) {
      setTimeout(() => {
        toast.success('새로운 알림이 도착했습니다!');
        getMessages(dispatch, userInfo);
      }, 500);
    }
  });

  return isAuthenticated && props.children;
}
